<template>
  <div>
    <h2 class="hl-variation-list">
      {{ $t('Menu.list.profiles.title') }}
    </h2>
    <ul class="default-option-list">
      <template v-for="(item, index) in profileList">
        <li v-bind:key="index" @click="changeItem(item.itemnumber, item.alerts)" :class="{'match' : item.match}">
          <img class="thumb"
               @error="$parent.setIconNotAvailable($refs['profile_' + index])"
               :ref="'profile_' + index"
               :src="(isAlloyCombi !== true) ?
                  appUrl + '/img/assets/profiles/' + index + '.jpg' :
                  $parent['getFinishIcon']('', '', item.itemnumber, false)"
               :srcset="(isAlloyCombi !== true) ?
                  appUrl + '/img/assets/profiles/' + index + '@2x.jpg' :
                  $parent['getFinishIcon']('', '', item.itemnumber, true)"
               :title="item.text"
               :alt="item.text">
          <p>
            {{ index }} <br/>
            {{ item.text }}
          </p>
        </li>
      </template>
      <li v-if="!all" @click="all = true">
        <img class="thumb" :src="appUrl+'/img/icons/next.svg'" :alt="$t('Menu.list.profiles.more')" />
        <span>{{ $t('Menu.list.profiles.more') }} &gt;</span>
      </li>
    </ul>
    <br/>
    <template v-if="profileListBrand && ! isVariationInSet()">
      <h2 class="hl-variation-list">{{ profileListBrandName }}</h2>
      <ul class="default-option-list">
        <template v-for="(item, index) in profileListBrand">
          <li v-bind:key="index" @click="changeItem(item.itemnumber, item.alerts)" :class="{'match' : item.match}">
            <img class="thumb"
                 @error="$parent.setIconNotAvailable($refs['profileBrand_' + index])"
                 :ref="'profileBrand_' + index"
                 :src="(ringLayout !== 'alloyCombi') ?
                    appUrl + '/img/assets/profiles/' + index + '.jpg' :
                    $parent['getFinishIcon']('', '', item.itemnumber, false)"
                 :srcset="(ringLayout !== 'alloyCombi') ?
                    appUrl + '/img/assets/profiles/' + index + '@2x.jpg' :
                    $parent['getFinishIcon']('', '', item.itemnumber, true)"
                 :title="item.text"
                 :alt="item.text">
            <p>
              {{ index }} <br/>
              {{ item.text }}
            </p>
          </li>
        </template>
        <li v-if="!allBrands" @click="allBrands = true">
          <img class="thumb" :src="appUrl+'/img/icons/next.svg'" :alt="$t('Menu.list.profiles.more')" />
          <span>{{ $t('Menu.list.profiles.more') }} &gt;</span>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
  import Config from "@/vuex/Config";
  import SetData from "@/vuex/SetData";

  export default {
    name: 'VariationsProfiles',
    props: [
      'possibleItems'
    ],
    data() {
      return {
        appUrl: Config.getters.getAppUrl,
        ringLayout: SetData.getters.getRingLayout,
        currentItemId: SetData.getters.getCurrentItemId,
        set: SetData.getters.getSet,
        all: true,
        allBrands: true,
        maxItems: 99,
        maxItemsBrand: 99
      }
    },
    methods: {
      changeItem: function (itemnumber, alerts) {
        this.$parent.$parent.changeItem(itemnumber, alerts);
      },
      isVariationInSet: function() {
        for (let itemIdx in this.set.items) {
          if (typeof this.set.items[itemIdx].description === 'object' &&
            this.set.items[itemIdx].description.isVariation &&
            this.set.items[itemIdx].description.jewelleryType < 1
          ) {
            return true;
          }
        }
        return false;
      },
    },
    computed: {
      isAlloyCombi: function() {
        return this.$parent.$parent.$parent['isCurrentItemAlloyCombi'](SetData.getters.getCurrentItemId);
      },
      profileList: function () {
        let list = {};

        let counter = 0;

        let length = Object.keys(this.possibleItems.list).length;
        let maxItems = (length < (this.maxItems + 1)) ? length : this.maxItems;

        for (let key in this.possibleItems.list) {
          if (this.all === true || counter < maxItems) {
            list[key] = this.possibleItems.list[key];
            counter++;
          }
        }

        return list;
      },
      profileListBrand: function () {
        let list = null;

        if (typeof this.possibleItems['listBrand'] === 'object') {
          let counter = 0;

          let length = Object.keys(this.possibleItems['listBrand'].items).length;
          let maxItems = (length < (this.maxItemsBrand + 1)) ? length : this.maxItemsBrand;

          if (length > 0) {
            list = {};
            for (let key in this.possibleItems['listBrand'].items) {
              if (this.allBrands === true || counter < maxItems) {
                list[key] = this.possibleItems['listBrand'].items[key];
                counter++;
              }
            }
          }
        }

        return list;
      },
      profileListBrandName: function() {
        let name = '';
        if (typeof this.possibleItems['listBrand'] === 'object') {
          name = this.possibleItems['listBrand'].name;
        }
        return name;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #app {
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      font-size: 1em;

      li {
        display: inline-block;
        margin: 0.75em 1em;
        width: 5em;
        vertical-align: top;
        cursor: pointer;

        @media (min-width: 992px) and (max-width: 1199px) {
          margin: 0.75em 0.75em;
        }

        span {
          font-size: 1em;
          display: block;
          text-align: center;
        }

        img.thumb {
          width: 4em;
          height: 4em;
        }
      }

      li.match {
        font-weight: bold;
        background-color: inherit;
        color: $black;

        img {
          border: solid 0.2rem $brandGold;
        }
      }
    }
  }
</style>
